export class BrowserHelper {
  static isSafari(): boolean {
    const ua = navigator.userAgent.toLowerCase();
    if (ua.indexOf('safari') > -1) {
      if (ua.indexOf('chrome') > -1 || ua.indexOf('crios') > -1 || ua.indexOf('fxios') > -1  || ua.indexOf('edgios') > -1 ) {
        return false; //Chrome, Firefox or Edge
      } else {
        return true; // Safari
      }
    } else {
      return false; //Some other browser
    }
  }
  static isIE(): boolean {
    const ua = navigator.userAgent.toLowerCase();
    const isIE = /msie\s|trident\//i.test(ua);
    if (!isIE) {
      return false;
    } else {
      return true;
    }
  }
  static showUAPrompt() {
    const ua = navigator.userAgent.toLowerCase();
    prompt(ua,ua);
  }
}
